import DisplayedTimeFormat from '../DisplayedTimeFormat/DisplayedTimeFormat.vue';

export default {
  name: 'PeriodsDisplay',
  components: {
    DisplayedTimeFormat,
  },
  props: {
    periods: {
      default: () => [],
      type: Array,
    },
  },
  data: () => ({
    perfix: `tko-${Math.random().toString(36).slice(2)}`,
    showPopover: false,
  }),
  computed: {
    firstPeriod() {
      return this.periods[0] || {};
    },
    hasOtherPeriods() {
      return this.periods.length > 1;
    },
    otherPeriods() {
      return this.periods.slice(1) || [];
    },
  },
  methods: {
    closePopover() {
      this.showPopover = false;
    },
    onBtnClick() {
      if (!this.hasOtherPeriods) {
        return;
      }
      this.showPopover = !this.showPopover;
    },
    onClickOutside(event) {
      if (!this.hasOtherPeriods) {
        return;
      }
      const btnId = `#${this.perfix}-periods-btn`;
      const popoverId = `#${this.perfix}-other-periods-popover`;
      const btn = document?.querySelector(btnId);
      const popover = document?.querySelector(popoverId);
      const { target } = event || {};
      if (!target || !popover) {
        return;
      }
      if (btn?.contains(target) || popover?.contains(target)) {
        return;
      }
      this.showPopover = false;
    },
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside);
    document.addEventListener('scroll', this.closePopover);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
    document.removeEventListener('scroll', this.closePopover);
  },
};
